import clsx from 'clsx';
import { CiCircleAlert } from 'react-icons/ci';
import { AuthCheckboxProps } from '@/types/props/components/auth';

export default function AuthCheckbox({
  checked,
  onChange,
  name,
  label,
  invalidMessage,
}: AuthCheckboxProps) {
  return (
    <div className="tw-w-full tw-relative tw-flex tw-items-center">
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={clsx('tw-hidden', {
          'tw-border-red-500': Boolean(invalidMessage),
        })}
      />
      <label
        htmlFor={name}
        className={clsx(
          'tw-flex tw-items-center tw-cursor-pointer tw-text-xs tw-font-plusJakartaSans tw-text-gray-500',
          {
            'tw-text-red-500': Boolean(invalidMessage),
          }
        )}
      >
        <div
          className={clsx(
            'tw-w-5 tw-h-5 tw-border tw-border-solid tw-border-platinum-gray tw-rounded-md tw-flex tw-items-center tw-justify-center tw-mr-2 tw-shrink-0',
            {
              'tw-bg-main tw-border-main': checked,
              'tw-border-red-500': Boolean(invalidMessage),
            }
          )}
        >
          {checked && <span className="tw-text-white tw-font-bold">✔</span>}
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        ></div>
      </label>
      {invalidMessage && (
        <span className="tw-text-red-500 tw-text-xs tw-ml-2">
          <CiCircleAlert className="tw-inline tw-mr-1" />
          {invalidMessage}
        </span>
      )}
    </div>
  );
}
